module.exports = __webpack_public_path__ + "img/search-suggested.7845de74.svg";